import { isResponseOk, useFetch } from "@swa-ui/fetch";

import { getPersistedCarProductData } from "../../carPersistence";
import { CAR_BOOKINGS_ENDPOINT } from "../../defines";
import { generateBookingPayload } from "../../generateBookingPayload";

/**
 * Hook that provides functionality to book a rental car using driver and flight confirmation data.
 * @returns {{ invokeCarBookingService: Function, isCarBookingLoading: Boolean }} An object containing the car booking service invocation function and loading state.
 */
export const useCarBooking = () => {
  const { loading: isCarBookingLoading, post, response } = useFetch();

  async function invokeCarBookingService(flightConfirmationData, driverDetails, creditCardDetails) {
    const result = { data: null, error: null, success: false };

    try {
      const payload = getCarBookingPayload(
        flightConfirmationData,
        driverDetails,
        creditCardDetails
      );

      const body = await post(CAR_BOOKINGS_ENDPOINT, payload);

      if (isResponseOk(response)) {
        const { data, meta } = body || {};

        result.meta = meta;
        result.data = data;
        result.success = true;
      } else {
        result.error = response;
      }
    } catch (error) {
      result.error = error;
    }

    return result;
  }

  function getCarBookingPayload(flightConfirmationData, driverDetails, creditCardDetails) {
    const { confirmationNumber, reservations } = flightConfirmationData;
    const carProductData = getPersistedCarProductData();
    const { firstName, flightNumber, lastName, loyaltyProgram, rapidRewardsNumber } = driverDetails;
    const supplierName = carProductData?.supplier?.basicInfo?.companyShortName;

    return generateBookingPayload(
      {
        confirmationNumber,
        email: reservations?.confirmationEmail,
        firstName,
        flightNumber,
        membershipID: rapidRewardsNumber,
        supplierLoyaltyID: loyaltyProgram,
        supplierName,
        surname: lastName,
      },
      creditCardDetails
    );
  }

  return { invokeCarBookingService, isCarBookingLoading };
};
